import React, { useEffect, useState } from 'react';
import { RootState, useSelector } from '../../redux/store';
import useLocales from '../../hooks/useLocales';
import getTradingCompanyName from '../../utils/getTradingCompanyName';
import type { ICellRendererParams } from 'ag-grid-community';

const TradingCompanyCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  const tradingCompanyCodes: string | string[] = params.value;
  // console.log(tradingCompanyCodes);
  const { currentLang } = useLocales();
  const { tradingCompany } = useSelector((state: RootState) => state.options);
  const [displayName, setDisplayName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  useEffect(() => {
    // 商社コードを商社名にマップする。マッチするものが見つからなかったらコードのままにする。
    const mappedCodes: string | string[] = Array.isArray(tradingCompanyCodes)
      ? tradingCompanyCodes.map((code) => {
          const tradingCompanyName: string = getTradingCompanyName(code, { tradingCompanies: tradingCompany, language: currentLang.value });
          return tradingCompanyName;
        })
      : getTradingCompanyName(tradingCompanyCodes, { tradingCompanies: tradingCompany, language: currentLang.value });
    setDisplayName(Array.isArray(mappedCodes) ? mappedCodes.join(', ') : mappedCodes);
  }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <span className="trading-company-name">{displayName}</span>;
};

export default TradingCompanyCellRenderer;
